import ActionButton from '@/components/Button/ActionButton';
import IconButton from '@/components/Button/IconButton';
import Input from '@/components/Input/Input';
import { HStack, VStack } from '@/components/Layout';
import { Text } from '@/components/Typography/Text';
import { useCommonTranslation } from '@/hooks/useCommonTranslation';
import { CFormItemBase, type CFormItemProps, buildCFormItem } from '../CFormItem';
type Props = CFormItemProps & {
  value: {
    number: string;
    displayOrder: number;
  }[];
  onChange: (value: {
    number: string;
    displayOrder: number;
  }[]) => void;
  addButtonLabel?: string;
  placeholder?: string;
};

/**
 * 内線番号などのシンプルなテキスト配列入力。
 * 編集時に行の追加・削除ができる。
 */
export const CFormExtensionNumberListItem = buildCFormItem((props: Props) => {
  const tc = useCommonTranslation();
  const values = props.value ?? [];
  const handleChange = (index: number, newValue: {
    number: string;
    displayOrder: number;
  }) => {
    const next = [...values];
    next[index] = newValue;
    props.onChange(next);
  };
  const handleAdd = () => {
    props.onChange([...values, {
      number: '',
      displayOrder: values.length + 1
    }]);
  };
  const handleRemove = (index: number) => {
    props.onChange(values.filter((_, i) => i !== index));
  };
  const validValues = values.filter(v => v.number.trim() !== '');
  const readComponent = <VStack className="gap-1">
      {validValues.length === 0 ? <Text variant="pSmall" className="text-neutral-muted-on-fill">
          -
        </Text> : validValues.map((v, index) => <Text key={`read-${index}`} variant="labelLarge">
            {v.number}
          </Text>)}
    </VStack>;
  const writeComponent = <VStack className="gap-3">
      {values.map((v, index) => <HStack key={`row-${index}`} className="gap-2 items-center">
          <Input value={v.number} onChange={e => handleChange(index, {
        number: e.target.value,
        displayOrder: v.displayOrder
      })} placeholder={props.placeholder} disabled={props.readonly} />
          {!props.readonly && <IconButton icon="Trash2Icon" variant="ghost" size="Small" className="shrink-0" onClick={() => handleRemove(index)} aria-label={tc('action.delete')} />}
        </HStack>)}
      {!props.readonly && <ActionButton icon="PlusIcon" variant="ghost" size="sm" className="self-start" onClick={handleAdd}>
          {props.addButtonLabel ?? tc('action.add')}
        </ActionButton>}
    </VStack>;
  return <CFormItemBase {...props} readComponent={readComponent} writeComponent={writeComponent} />;
});